import React from "react";
import { Send, ArrowRight } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import useReveal from "../../hooks/useReveal";

const TELEGRAM_USERNAME = "nmn_energy";

const CTABanner = () => {
  const { t } = useLanguage();
  const ref = useReveal();

  const prefilled = encodeURIComponent(t.contact.prefilledMessage);
  const telegramHref = `https://t.me/${TELEGRAM_USERNAME}?text=${prefilled}`;

  return (
    <section
      id="cta"
      ref={ref}
      data-testid="cta-banner-section"
      className="relative py-20 md:py-28 bg-black"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20">
        <div
          className="reveal relative overflow-hidden border border-[#e8d4a8]/20 bg-gradient-to-br from-[#121212] via-[#0a0a0a] to-[#0a0a0a]"
          data-testid="cta-banner-card"
        >
          {/* decorative glow */}
          <div className="pointer-events-none absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-[radial-gradient(circle,rgba(232,212,168,0.14)_0%,transparent_60%)]"></div>
          <div className="pointer-events-none absolute -bottom-40 -left-32 w-[500px] h-[500px] rounded-full bg-[radial-gradient(circle,rgba(232,212,168,0.06)_0%,transparent_60%)]"></div>

          <div className="relative p-10 md:p-16 lg:p-20 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
            <div className="lg:col-span-7">
              <p className="font-mono-l text-[11px] text-[#e8d4a8] mb-5 flex items-center gap-3">
                <span className="w-6 h-px bg-[#e8d4a8]"></span>
                {t.cta.eyebrow}
              </p>
              <h2
                className="font-display text-white text-3xl md:text-4xl lg:text-5xl leading-[1.1] text-balance mb-6"
                data-testid="cta-banner-title"
              >
                {t.cta.title}
              </h2>
              <p className="text-white/65 text-base md:text-lg leading-relaxed font-light max-w-xl">
                {t.cta.subtitle}
              </p>
            </div>

            <div className="lg:col-span-5 flex flex-col gap-4">
              <a
                href={telegramHref}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center justify-between gap-3 px-7 py-5 bg-[#e8d4a8] text-black text-[12px] tracking-[0.2em] uppercase font-medium hover:bg-white transition-colors duration-300"
                data-testid="cta-banner-telegram-btn"
              >
                <span className="flex items-center gap-3">
                  <Send size={15} strokeWidth={1.5} />
                  {t.cta.secondary}
                </span>
                <ArrowRight
                  size={16}
                  className="transition-transform duration-300 group-hover:translate-x-1"
                />
              </a>
              <a
                href="#contact"
                className="group inline-flex items-center justify-between gap-3 px-7 py-5 border border-[#e8d4a8]/50 text-[#e8d4a8] text-[12px] tracking-[0.2em] uppercase hover:bg-[#e8d4a8]/10 transition-all duration-300"
                data-testid="cta-banner-book-btn"
              >
                <span>{t.cta.primary}</span>
                <ArrowRight
                  size={16}
                  className="transition-transform duration-300 group-hover:translate-x-1"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
